<template>
  <div class="page-container" ref="goldApple" id="goldApplecontainer" v-images-loaded="loaded">
    <div class="bigscroller">
      <router-link  class="home-icon-container" :to="{ name: 'home' }"> 
        <img class="home-icon" :src="homeIcon" alt="home">
      </router-link>
      <Menu />
      <MobileMenu />
      <section id="goldApple">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="bannerGold"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <section id="ritualGold">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="ritualGold"></router-view>
        <router-view name="dritualGold"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <section id="mixologiaGold">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="mixologiaGold"></router-view>
        <router-view name="dmixologiaGold"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <section id="maridajeGold">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="maridajeGold"></router-view>
         <router-view name="othersGold"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <div class="mRetailers">
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/Menu";
import MobileMenu from "@/components/MobileMenu";
import VueScrollTo from "vue-scrollto";
import { mapActions, mapGetters } from "vuex";
import Footer from "@/components/FooterHome";
import tagFunctions from '@/utils/tagFunctions.js'
import homeIcon from "@/assets/home-icon.png"
import imagesLoaded from 'vue-images-loaded'

export default {
  name: "goldApple",
  props: ["id"],
  components: {
    Menu,
    MobileMenu,
    Footer,
  },
  directives: {
    imagesLoaded
},
  computed: {
    ...mapGetters([
      "getActiveSection",
      "getTriggerSpring",
      "getEdgeScrolling",
      "getScrollMotion",
      "isLoaded"
    ]),
  },
  created() {},
  data() {
    return {
      baseRoute: 'goldApple',
      showModal: false,
      wichModal: "terms",
      fixedLel: true,
      homeIcon
    };
  },
  mounted() {
    this.setLoadStatus({status: false})
    tagFunctions.evPageViewPush('Gold Apple')
    //this.checkRouteForInitialScroll();
    VueScrollTo.scrollTo(`#app`, 1, {
          container: "body",
          easing: "linear",
          offset: 0,
          force: true,
          cancelable: true,
          // onStart: function(element) {},
          // onDone: function(element) {},
          // onCancel: function() {},
          x: false,
          y: true,
        });
  },
  methods: {
    loaded(){
      this.setLoadStatus({status: true})
    },
    ...mapActions({
      goToSection: "goToSection",
      setActiveSection: "setActiveSection",
      resetEdgeScrollingAction: "resetEdgeScrolling",
      setEdgeScrollingAction: "setEdgeScrolling",
      setLoadStatus: "setLoadStatus"
    }),
    popUpModal(modalType) {
      this.showModal = true;
      this.wichModal = modalType;
    },
    visibilityChanged(isVisible, entry) {
      if (isVisible) {
      this.$router.push({ name: entry.target.offsetParent.id }).catch(err => {
    // Ignore the vuex err regarding  navigating to the page they are already on.
    if (
      err.name !== 'NavigationDuplicated' &&
      !err.message.includes('Avoided redundant navigation to current location')
    ) {
      // But print any other errors to the console
      throw err;
    }
  });
        this.setActiveSection({
          willScroll: false,
          section: entry.target.offsetParent.id==this.$route.name?'':this.baseRoute+'/'+entry.target.offsetParent.id,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/containers/GoldApple.scss";
@import "~@/styles/variables.scss";
</style>
